import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterWienSchoenbrunn() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-wien-schoenbrunn-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-wien-schoenbrunn-heading">WETTER</h1>
        </div>

        <Wetter ort="wien-schoenbrunn" />
      </div>
    </div>
  );
}

export default WetterWienSchoenbrunn;
